import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { getRiaPlansByServiceLevel } from '@api/ria';
import { RiaPlan } from 'types/plan';
import store from '..';

export interface PlansState {
	starterPlans: Array<RiaPlan>;
	basicPlan: RiaPlan | null;
	corePlans: Array<RiaPlan>;
	corePlansIRA: Array<RiaPlan>;
	advancedPlans: Array<RiaPlan>;
	premiumPlans: Array<RiaPlan>;
}

@Module({
	dynamic: true,
	namespaced: true,
	name: 'plans',
	store
})
class PlansModule extends VuexModule {
	starterPlans: Array<RiaPlan> = [];
	basicPlan: RiaPlan | null = null;
	corePlans: Array<RiaPlan> = [];
	corePlansIRA: Array<RiaPlan> = [];
	advancedPlans: Array<RiaPlan> = [];
	premiumPlans: Array<RiaPlan> = [];

	@Action
	public async getCoreIraPlans(): Promise<Array<RiaPlan>> {
		if (this.corePlansIRA.length === 0) {
			const corePlansIRA = await getRiaPlansByServiceLevel('CORE', true);
			this.UPDATE_CORE_PLANS_IRA(corePlansIRA);
		}
		return this.corePlansIRA;
	}

	@Action
	public async getBasicPlan(): Promise<RiaPlan> {
		if (this.basicPlan === null) {
			const basicPlanArray = await getRiaPlansByServiceLevel('BASIC', false);
			const basicPlan = basicPlanArray[0];
			this.UPDATE_BASIC_PLAN(basicPlan);
			return basicPlan;
		}
		return this.basicPlan;
	}

	@Action
	public async getCorePlans(): Promise<Array<RiaPlan>> {
		if (this.corePlans.length === 0) {
			const corePlans = await getRiaPlansByServiceLevel('CORE', false);
			this.UPDATE_CORE_PLANS(corePlans);
		}
		return this.corePlans;
	}

	@Action
	public async getAdvancedPlans(): Promise<Array<RiaPlan>> {
		if (this.advancedPlans.length === 0) {
			const advancedPlans = await getRiaPlansByServiceLevel('ADVANCED', false);
			this.UPDATE_ADVANCED_PLANS(advancedPlans);
		}
		return this.advancedPlans;
	}

	@Mutation
	public UPDATE_CORE_PLANS_IRA(plans: Array<RiaPlan>): void {
		this.corePlansIRA = plans;
	}

	@Mutation
	public UPDATE_BASIC_PLAN(plan: RiaPlan): void {
		this.basicPlan = plan;
	}

	@Mutation
	public UPDATE_CORE_PLANS(plans: Array<RiaPlan>): void {
		this.corePlans = plans;
	}

	@Mutation
	public UPDATE_ADVANCED_PLANS(plans: Array<RiaPlan>): void {
		this.advancedPlans = plans;
	}
}

export const plans = getModule(PlansModule);
